<tracking-page-main
  [shop]="shop$ | async"
  [trackingPageConfiguration]="trackingPageConfiguration$ | async"
  [isLoading]="isConfigurationLoading$ | async"
  [shopRequirements]="shopRequirements$ | async"></tracking-page-main>
